import { computed, defineComponent, ref } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'CurrencyListItem',
    emits: ['currencySelected'],
    props: {
        currency: {
            type: Object,
            required: true,
        },
    },
    setup(props, { emit }) {
        const transactionsStore = useTransactionsStore();
        const { selectedCurrency, selectedCrypto, countryConfig } = storeToRefs(transactionsStore);
        const currencyObject = ref(props.currency);
        const selected = ref(false);
        const onItemClicked = () => {
            selected.value = true;
            emit('currencySelected', currencyObject.value.symbol, currencyObject.value.standard, currencyObject.value.networkType);
        };
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const optionSelected = computed(() => {
            const currency = ['XOF', 'XAF'].includes(selectedCurrency.value.currency)
                ? `${selectedCurrency.value.currency}_${countryConfig.value.country}`
                : selectedCurrency.value.currency;
            const currencySelected = currencyObject.value.symbol === currency;
            const coinSelected = currencyObject.value.symbol === selectedCrypto.value.token &&
                currencyObject.value.standard === selectedCrypto.value.standard &&
                currencyObject.value.networkType === selectedCrypto.value.networkType;
            return currencySelected || coinSelected;
        });
        return {
            currencyObject,
            onItemClicked,
            selected,
            onKeyPress,
            optionSelected,
        };
    },
});
